import React, { useEffect, useRef } from "react";
import "../../styles/aiEvaluation.scss";

// Overlay shell for the evaluation dialogs. Locks page scroll while open and
// closes on Escape or a click on the backdrop. Escape is handled on the dialog
// itself (not the document) so an open MUI select menu inside it, which stops
// the event, closes only the menu.
function EvaluationModal({ open, onClose, className, children }) {
  const dialogRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const body = document.body;
    const html = document.documentElement;
    const prevBody = body.style.overflow;
    const prevHtml = html.style.overflow;
    body.style.overflow = "hidden";
    html.style.overflow = "hidden";
    if (dialogRef.current) dialogRef.current.focus();
    return () => {
      body.style.overflow = prevBody;
      html.style.overflow = prevHtml;
    };
  }, [open]);

  if (!open) return null;

  return (
    <div
      className="ai-eval-overlay"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget && onClose) onClose();
      }}
    >
      <div
        ref={dialogRef}
        tabIndex={-1}
        role="dialog"
        aria-modal="true"
        className={`ai-eval-dialog ai-eval-scope ${className || ""}`}
        onKeyDown={(e) => {
          if (e.key === "Escape" && onClose) onClose();
        }}
      >
        {children}
      </div>
    </div>
  );
}

export default EvaluationModal;
